module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/making_sustainable"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Making a Sustainable Kitchen")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preparing"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Preparing your Zero Waste Kitchen")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/tools_materials"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Tools and Materials")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Upcycled Apron")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Beeswax Wraps")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Beeswax Lunch Bags")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Bias Bound Washcloths")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Fruit Bag Scourer")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Jumper Tea Cosy")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Universal Crochet Pot Cover")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Cat Head Trivet")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Reusable Wipes")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Wrap for Life")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Denim Storage Baskets")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Bird Pot Holder")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Net Produce Bags")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Coffee Sack Tote Bag")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Table Tidy")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Popcorn Bag")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Cutlery Caddy")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Family Pocket Planner")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Milk Bottle Storage Pots")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Net Curtain Bottle Washer")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/techniques",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Techniques")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/templates",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Templates")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/suppliers",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Suppliers")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/inspiration",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Inspiration")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("About the Authors")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/thanks",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Our Thanks")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0